import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gx-4 gx-lg-5 padding-bottom-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "display-3 mt-4" }, "Tack för din beställning!"),
  /*#__PURE__*/_createElementVNode("h2", { class: "display-6 mt-4" }, "Göm inte att prenumera på vårat nyhetsbrev")
], -1)
const _hoisted_3 = { class: "col-12 d-flex justify-content-center align-items-center pt-5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-house",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" })
], -1)

import { onMounted } from 'vue';
    import { useMeta } from '@/composables/meta';
    import { dontUseCanonical } from '@/composables/canonical';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderConfirm',
  setup(__props) {

    onMounted(async () => {
        useMeta('Tack för din beställning!', 'Beställningen är genomförd. Tack för ditt köp! Detaljer om ditt köp kommer på mail.');
        dontUseCanonical();
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: { name: 'Start' },
        custom: ""
      }, {
        default: _withCtx(({ navigate }) => [
          _createElementVNode("button", {
            role: "button",
            onClick: navigate,
            class: "btn btn-primary btn-custom-size mt-5"
          }, [
            _hoisted_5,
            _createTextVNode(" TILL STARTSIDAN ")
          ], 8, _hoisted_4)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})